export const API_CODES = {
    NDIS_ALREADY_USED: 256,
    MAILGUN_ERROR: 271,
    NO_USER_FOUND_EMAIL: 281,
};
